export default class SelectTopic {
  constructor(context) {
    this.context = context;
  }

  run(params) {
    this.context.analytics.track('Topics Menu - Topic Selected', params);
  }
}
